/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeactivateAccessKeyResponse
 */
export interface DeactivateAccessKeyResponse {
    /**
     * Whether the deactivation was successful
     * @type {boolean}
     * @memberof DeactivateAccessKeyResponse
     */
    success?: boolean;
}

/**
 * Check if a given object implements the DeactivateAccessKeyResponse interface.
 */
export function instanceOfDeactivateAccessKeyResponse(value: object): value is DeactivateAccessKeyResponse {
    let isInstance = true;

    return isInstance;
}

export function DeactivateAccessKeyResponseFromJSON(json: any): DeactivateAccessKeyResponse {
    return DeactivateAccessKeyResponseFromJSONTyped(json, false);
}

export function DeactivateAccessKeyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeactivateAccessKeyResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': !exists(json, 'success') ? undefined : json['success'],
    };
}

export function DeactivateAccessKeyResponseToJSON(value?: DeactivateAccessKeyResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
    };
}

